import { useMemo } from "react";
import { ConsentPolicyType } from "../../../common/enums";
import { IPolicyViewModel } from "../models/policyViewModel";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import styles from "./PolicyDialog.module.scss";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";

interface IPolicyDialogProps {
  allPolicies?: IPolicyViewModel[];
  selectedPolicy?: ConsentPolicyType;
  onClose: () => void;
}

export const PolicyDialog = ({
  allPolicies,
  selectedPolicy,
  onClose,
}: IPolicyDialogProps) => {
  const policy = useMemo(() => {
    return allPolicies?.find((x) => x.type === selectedPolicy);
  }, [selectedPolicy, allPolicies]);

  if (!allPolicies) {
    return;
  }

  return (
    <>
      <span className={styles.lastModifiedOnText}>
        Последна актуализация: {dateUtility.formatDate(policy?.lastModifiedOn)}
      </span>
      <div dangerouslySetInnerHTML={{ __html: policy?.policy ?? "" }} />
      <DefaultButton
        className={styles.button}
        label={"Затвори"}
        onClick={onClose}
        width={"100px"}
      />
    </>
  );
};
